module.exports = __webpack_public_path__ + "images/backgrounds/snow-bokeh/medium.9f4c60883dec8b5aa5bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/snow-bokeh/medium.jpg
// module id = zc2/
// module chunks = 13